import Vue from 'vue';
import Vuex from 'vuex';
import { CHANGE_THEME } from './mutation-types.js';
import { Theme, ThemeEnum, AppListStyle } from '@/models/theme.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    strict: debug,

    state: {
        NavBarBackHomeButton: false, // 返回主页
        NavBarBackButton: false, // 返回上一级路由
        theme: {
            themeType: Theme.Default,
            appListStyle: AppListStyle.Default,
        },
    },

    mutations: {
        ToggleNavBarBackHomeButton(state, value) {
            state.NavBarBackHomeButton = value;
        },
        ToggleNavBarBackButton(state, value) {
            state.NavBarBackButton = value;
        },
        [CHANGE_THEME](state, theme) {
            let themeType;
            try {
                themeType = Theme[ThemeEnum[theme]];
            } catch (error) {
                return;
            }
            if (!themeType) return;

            document.body.className = themeType;
            state.theme.themeType = themeType;
            state.theme.appListStyle =
                themeType === Theme.BlackAndRed2 ? AppListStyle.Menu : AppListStyle.Default;
        },
    },

    getters: {
        themeType(state) {
            return state.theme.themeType;
        },
        appListStyle(state) {
            return state.theme.appListStyle;
        },
    },
});
